import { FC, ReactElement } from 'react'

import { SvgIconProps } from '@/components/Icon/Icon'

export const IconHamburger: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg aria-hidden="true" viewBox="0 0 18 12" className={`icon-component ${className}`}>
        <path d="M0 0H18V2H0V0ZM0 5H18V7H0V5ZM0 10H18V12H0V10Z" />
    </svg>
)
